var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSquareCheck = function SvgSquareCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M6.25 5.625a.627.627 0 0 0-.625.625v12.5c0 .344.281.625.625.625h12.5a.627.627 0 0 0 .625-.625V6.25a.627.627 0 0 0-.625-.625zm-2.5.625c0-1.379 1.121-2.5 2.5-2.5h12.5c1.379 0 2.5 1.121 2.5 2.5v12.5c0 1.379-1.121 2.5-2.5 2.5H6.25a2.5 2.5 0 0 1-2.5-2.5zm13.164 4.414-5 5a.934.934 0 0 1-1.324 0l-2.5-2.5a.937.937 0 0 1 1.324-1.324l1.836 1.836 4.336-4.34a.937.937 0 0 1 1.324 1.324z"
  })));
};
export default SvgSquareCheck;